import { useEffect } from 'react';
import { EmptyState } from '@/components/States';
import { useI18n } from '@/client/i18n/I18nContext';

/** Was this page load itself a reload? (Navigation Timing; false when unknown.) */
function isReloadedLoad(): boolean {
  try {
    const [nav] = performance.getEntriesByType('navigation') as PerformanceNavigationTiming[];
    return nav?.type === 'reload';
  } catch {
    return false;
  }
}

/**
 * errorElement for lazily loaded routes. A deploy renames the hashed chunks, so
 * a tab opened before it can't load the old one (the Worker answers the SPA
 * shell instead). By the time this renders the URL is already the target page,
 * so one reload picks up the new build. If this load already was a reload, show
 * a way out instead of looping. No storage involved.
 */
export function RouteLoadError() {
  const { t } = useI18n();
  const retry = !isReloadedLoad();

  useEffect(() => {
    if (retry) window.location.reload();
  }, [retry]);

  if (retry) return null;
  return (
    <div className="container">
      <EmptyState
        title={t('common.loadError')}
        action={
          <button type="button" className="btn" onClick={() => window.location.reload()}>
            {t('common.retry')}
          </button>
        }
      />
    </div>
  );
}
